import {NodeViewWrapper} from "@tiptap/react";
import {useEffect, useState} from "react";

export const FormFieldNodeView = ({node, updateAttributes, editor}) => {
  const [value, setValue] = useState(node.attrs.value || "");

  useEffect(() => {
    setValue(node.attrs.value || "");
  }, [node.attrs.value]);

  const handleChange = (e) => {
    const newValue = e.target.value;

    setValue(newValue);
    updateAttributes({value: newValue});
  };

  return (
    <NodeViewWrapper as="span" className="ttInlineNode tt-form-field">
      <input
        type="text"
        value={value}
        disabled={!editor.isEditable}
        placeholder={node.attrs.placeholder ?? "Type here…"}
        size={Math.max(1, value.length - 2)}
        onChange={handleChange}
        onKeyDown={(e) => e.stopPropagation()}
        className="tt-form-field__input"
      />
    </NodeViewWrapper>
  );
};
